import { CertificateItem } from "../types/certificates";
import { CallResult, doApiDelete, doApiGet, doApiPatch, doApiPost } from "./Requests";
import { PaginationParameters, PaginationResult, toQueryParameters } from "./Pagination";
import { CertificateUploadData } from "../components/common/table/UploadBtn";

export const certificatesApi = {
  getCertificates: (pagination: PaginationParameters): Promise<CallResult<PaginationResult<CertificateItem>>> =>
    doApiGet(`/api/companies/current/documentmanagement?${toQueryParameters(pagination)}`),

  getAllCertificates: async (): Promise<CallResult<CertificateItem[]>> => {
    return await doApiGet("/api/companies/current/documentmanagement");
  },

  createCertificate: async (certificateData: Partial<CertificateItem>): Promise<CallResult<CertificateItem>> => {
    return await doApiPost("/api/companies/current/certificates/documentmanagement", certificateData);
  },

  editCertificate: async (id: number, certificateData: Partial<CertificateItem>): Promise<CallResult<CertificateItem>> => {
    return await doApiPatch(`/api/companies/current/certificates/documentmanagement/${id}`, certificateData);
  },

  deleteCertificate: async (id: number): Promise<CallResult<null>> => {
    return await doApiDelete(`/api/companies/current/certificates/documentManagement/${id}`);
  },

  uploadCertificateFile: async (fileDataToSend: CertificateUploadData): Promise<CallResult<any>> => {
    return await doApiPost(
      `/api/companies/current/fileexchange/${fileDataToSend.documentExchangeWalletId}/file`,
      fileDataToSend.filePayload
    );
  },

  deleteCertificateFile: async (documentExchangeWalletId: number,documentId: number): Promise<CallResult<any>> => {
    return await doApiDelete(
      `/api/companies/current/fileexchange/${documentExchangeWalletId}/file/${documentId}`
    );
  },
};
